import React from 'react';

const LoadingScreen = () => {
    return (
        <div className="fixed inset-0 bg-[#05091a] flex flex-col items-center justify-center z-[9999]">
            <div className="flex flex-col items-center">
                {/* Simplified Emblem */}
                <div className="mb-8">
                    <img
                        src="/brand/GoNova_amblem_white_transparent.png"
                        alt="Go Nova"
                        className="w-16 h-16 object-contain opacity-80"
                    />
                </div>

                {/* Minimalist Status */}
                <div className="flex flex-col items-center gap-4">
                    <div className="flex items-center gap-3">
                        <div className="w-1 h-1 bg-blue-500 rounded-full animate-pulse"></div>
                        <span className="text-[10px] font-bold text-white uppercase tracking-[0.4em]">
                            System <span className="text-blue-500">Syncing</span>
                        </span>
                    </div>

                    {/* Ultra-light Progress Bar */}
                    <div className="w-32 h-[1px] bg-white/10 relative overflow-hidden">
                        <div className="absolute inset-0 bg-blue-500 w-full h-full animate-loading-slide"></div>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes loading-slide {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                .animate-loading-slide {
                    animation: loading-slide 1s infinite ease-in-out;
                }
            `}</style>
        </div>
    );
};

export default LoadingScreen;
